"use client";

import { lazy, Suspense } from "react";
import { useInViewOnce } from "@/features/shared/hooks/use-in-view-once";

// Mesmo padrão de wall-of-love-section-lazy.tsx — adia o download+parse
// deste chunk até o usuário estar prestes a rolar até a seção, tirando-o do
// caminho crítico do LCP/TBT inicial da Home (única página que a usa).
const RealParceirosEliteSection = lazy(() =>
  import("./parceiros-elite-section").then((m) => ({ default: m.ParceirosEliteSection })),
);

function ParceirosEliteSectionPlaceholder() {
  return <div aria-hidden="true" className="relative py-24 sm:py-28 overflow-hidden bg-[#f4f7fb]" />;
}

function ParceirosEliteSection() {
  const { ref, inView } = useInViewOnce<HTMLDivElement>();

  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<ParceirosEliteSectionPlaceholder />}>
          <RealParceirosEliteSection />
        </Suspense>
      ) : (
        <ParceirosEliteSectionPlaceholder />
      )}
    </div>
  );
}

export { ParceirosEliteSection };
